import { render, staticRenderFns } from "./export-test.vue?vue&type=template&id=3e23591a&scoped=true"
import script from "./export-test.vue?vue&type=script&lang=js"
export * from "./export-test.vue?vue&type=script&lang=js"
import style0 from "./export-test.vue?vue&type=style&index=0&id=3e23591a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23591a",
  null
  
)

export default component.exports